/* ============================================================
   WildKind Wishlist — wk-wishlist.js
   Vanilla JS, no dependencies, loaded with `defer`.
   localStorage key "wk_wishlist" = array of product handles.
   - Heart toggle on every product card (collection grids,
     search, recommendations) via injection + MutationObserver.
   - Save button on the PDP buy box.
   - Header heart w/ count badge injected next to the cart icon.
   Everything is wrapped defensively: a failure here must never
   break the storefront.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'wk_wishlist';
  var HEART_PATH = 'M12 20.8 10.55 19.48C5.4 14.84 2 11.78 2 8.9 2 6.02 4.42 3.7 7.5 3.7c1.74 0 3.41.83 4.5 2.15 1.09-1.32 2.76-2.15 4.5-2.15 3.08 0 5.5 2.32 5.5 5.2 0 2.88-3.4 5.94-8.55 10.58L12 20.8Z';

  function heartSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="' + HEART_PATH + '" stroke-linejoin="round"/></svg>';
  }

  function read() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* noop */ }
    try { document.dispatchEvent(new CustomEvent('wk:wishlist:change', { detail: { handles: list.slice() } })); } catch (e2) { /* noop */ }
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var l = read();
    var i = l.indexOf(h);
    var added = i === -1;
    if (added) { l.unshift(h); } else { l.splice(i, 1); }
    write(l);
    return added;
  }

  window.WKWishlist = {
    read: read,
    has: has,
    toggle: toggle,
    remove: function (h) { var l = read(); var i = l.indexOf(h); if (i !== -1) { l.splice(i, 1); write(l); } }
  };

  function handleFrom(el) {
    try {
      var a = (el.matches && el.matches('a[href*="/products/"]')) ? el : el.querySelector('a[href*="/products/"]');
      if (!a) return null;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  /* ---------- Card hearts ---------- */
  function decorateCards() {
    try {
      var cards = document.querySelectorAll('.product-card');
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        if (card.querySelector('.wk-wish-btn')) continue;
        var h = handleFrom(card);
        if (!h) continue;
        card.classList.add('wk-wish-host');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'wk-wish-btn' + (has(h) ? ' is-saved' : '');
        b.setAttribute('data-wk-handle', h);
        b.setAttribute('aria-label', has(h) ? 'Remove from wishlist' : 'Save to wishlist');
        b.innerHTML = heartSvg();
        card.appendChild(b);
      }
    } catch (e) { /* noop */ }
  }

  /* ---------- PDP save button ---------- */
  function initPdp() {
    try {
      var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      var h = decodeURIComponent(m[1]);
      var info = document.querySelector('.product-information');
      if (!info || info.querySelector('.wk-wish-pdp')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wk-wish-pdp' + (has(h) ? ' is-saved' : '');
      btn.setAttribute('data-wk-handle', h);
      btn.innerHTML = heartSvg() + '<span class="wk-wish-pdp__label">' + (has(h) ? 'Saved to wishlist' : 'Save to wishlist') + '</span>';
      var atc = info.querySelector('.add-to-cart-button');
      var host = null;
      if (atc) {
        host = atc.closest('product-form-component') || atc.closest('form') || atc.parentElement;
      }
      if (host && host.parentElement) {
        host.insertAdjacentElement('afterend', btn);
      } else {
        info.appendChild(btn);
      }
    } catch (e) { /* noop */ }
  }

  /* ---------- Header heart + badge ---------- */
  function initHeader() {
    try {
      if (document.querySelector('.wk-wish-header')) return;
      var cartIcon = document.querySelector('.header-actions__cart-icon');
      var anchor = cartIcon ? (cartIcon.closest('a, button') || cartIcon) : null;
      var link = document.createElement('a');
      link.className = 'wk-wish-header';
      link.href = '/pages/wishlist';
      link.setAttribute('aria-label', 'My wishlist');
      link.innerHTML = heartSvg() + '<span class="wk-wish-badge" aria-hidden="true"></span>';
      if (anchor && anchor.parentElement) {
        anchor.parentElement.insertBefore(link, anchor);
      } else {
        var actions = document.querySelector('.header-actions');
        if (!actions) return;
        actions.insertBefore(link, actions.firstChild);
      }
      updateBadge();
    } catch (e) { /* noop */ }
  }

  function updateBadge() {
    try {
      var b = document.querySelector('.wk-wish-badge');
      if (!b) return;
      var n = read().length;
      b.textContent = n > 99 ? '99+' : String(n);
      b.classList.toggle('is-visible', n > 0);
    } catch (e) { /* noop */ }
  }

  function syncHearts() {
    try {
      var btns = document.querySelectorAll('.wk-wish-btn, .wk-wish-pdp');
      for (var i = 0; i < btns.length; i++) {
        var h = btns[i].getAttribute('data-wk-handle');
        if (!h) continue;
        var saved = has(h);
        btns[i].classList.toggle('is-saved', saved);
        var label = btns[i].querySelector('.wk-wish-pdp__label');
        if (label) label.textContent = saved ? 'Saved to wishlist' : 'Save to wishlist';
      }
    } catch (e) { /* noop */ }
  }

  /* ---------- Click handling (capture: beat card overlay links) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.wk-wish-btn, .wk-wish-pdp') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var h = btn.getAttribute('data-wk-handle');
    if (!h) return;
    var added = toggle(h);
    btn.classList.toggle('is-saved', added);
    btn.classList.remove('wk-pop');
    void btn.offsetWidth;
    btn.classList.add('wk-pop');
    btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Save to wishlist');
    var label = btn.querySelector('.wk-wish-pdp__label');
    if (label) label.textContent = added ? 'Saved to wishlist' : 'Save to wishlist';
    updateBadge();
  }, true);

  document.addEventListener('wk:wishlist:change', function () { updateBadge(); syncHearts(); });
  window.addEventListener('storage', function (ev) { if (ev && ev.key === KEY) { updateBadge(); syncHearts(); } });

  /* ---------- Boot + keep up with re-rendered content ---------- */
  var rafPending = false;
  function refresh() {
    if (rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(function () {
      rafPending = false;
      decorateCards();
      initHeader();
      initPdp();
    });
  }

  function init() {
    initHeader();
    initPdp();
    decorateCards();
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { refresh(); return; }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* noop */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
